import {
  Button,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_TVCHANNELS,
} from '../../../../../constants/RoleConsts';
import {
  CHANNEL_DRM,
  CHANNEL_FILTER_DATA,
  LANGUAGES,
  TVCHANNEL_CHANNELS_CREATE,
  TVCHANNEL_CHANNELS_EDIT,
  TVCHANNEL_CHANNELS_VIEW,
} from '../../../../../constants/TvChannelsConst';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import {
  changeTVChannelStatus,
  deleteTVChannel,
  uploadBulkTvChannelsByCSV,
} from '../../../../../utils/cmsUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  bouquetSelector,
  categorySelector,
  channelSelector,
  fetchAllBouquets,
  fetchAllCategorys,
  fetchAllChannels,
  fetchChannelNumberList,
  setChannelsSuccess,
} from '../../../cmsSlice';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { updateLiveTvOrders, sortChannels } from '../../../../../utils/PropertyAPIUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import { isNumberValid, validateAlphanumeric, validateUrl } from '../../../../../utils/formUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';

const arrayMove = (arr, from, to) => {
  const copy = [...arr];
  const [moved] = copy.splice(from, 1);
  copy.splice(to, 0, moved);
  return copy;
};
const renumberToCurrentOrder = (orderedList, originalList) => {
  const sortedNumbers = originalList
    .map((x) => x.number)
    .filter((n) => /^\d+$/.test(String(n)))
    .map((n) => parseInt(n, 10))
    .sort((a, b) => a - b)
    .map((n) => String(n));
  return orderedList.map((item, idx) => ({
    ...item,
    number: sortedNumbers[idx] ?? String(idx + 1),
  }));
};

const ChannelList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const channelList = useSelector(channelSelector);
  const categoryList = useSelector(categorySelector);
  const bouquetList = useSelector(bouquetSelector);

  const [channel, setChannel] = useState([]);
  const [loading, setLoading] = useState(true);
  const [channelFilter, setChannelFilter] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    channel: null,
  });
  const [filterDataList, setFilterDataList] = useState([]);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [isSortAvailable, setIsSortAvailable] = useState(false);
  const [dragEnabled, setDragEnabled] = useState(true);
  const [isSaveMode, setIsSaveMode] = useState(false);
  const showSort = !isSaveMode && isSortAvailable;

  useEffect(() => {
    setFilterDataList(CHANNEL_FILTER_DATA);
  }, []);

  useEffect(() => {
    setChannel(channelList || []);
    setFilteredBaseList(channelList || []);
    setLoading(false);
    setSearchText('');

    if (channelList && channelList?.length > 0) {
      const nums = channelList
        .map((x) => (/^\d+$/.test(x.number) ? parseInt(x.number, 10) : null))
        .filter((n) => typeof n === 'number')
        .sort((a, b) => a - b);

      const hasGap = nums?.some((n, i) => i > 0 && n - nums[i - 1] !== 1);
      setIsSortAvailable(hasGap);
    } else {
      setIsSortAvailable(false);
    }
    setIsSaveMode(false);
  }, [channelList]);
  const handleDragEnd = (result) => {
    const { source, destination } = result || {};
    if (!destination) return;
    if (source.droppableId === destination.droppableId && source.index === destination.index)
      return;
    const start = rowsPerPage > 0 ? page * rowsPerPage : 0;
    const from = start + source.index;
    const to = start + destination.index;
    const reordered = arrayMove(channel, from, to);
    const withRenumber = renumberToCurrentOrder(reordered, channel);
    setChannel(withRenumber);
    setIsSaveMode(true);
    setIsSortAvailable(false);
    setVisible(true);
  };

  const isMissingNumber = (numArray) => {
    for (let i = 1; i < numArray.length; i++) {
      if (numArray[i] - numArray[i - 1] != 1) {
        return true;
      }
    }
  };

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const filteredRows = await filteredBaseList.filter((item) => {
      return (
        item.name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.categoryName.toLowerCase().includes(searchText.toLowerCase()) ||
        item.code.toLowerCase().includes(searchText.toLowerCase())
      );
    });
    onsetPage(0);
    if (!searchText) {
      setChannel(filteredBaseList?.length ? filteredBaseList : channelList);
    } else {
      setChannel(filteredRows);
    }
  };

  const deleteChannel = async (e) => {
    e.stopPropagation();
    resetFilterDataList();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description:
        'This action cannot be reversed. Subsequent channel numbers will be reordered sequentially following this deletion.',
      status: true,
      anchorEl: null,
    }));
  };

  const deleteChannelAPICall = async (e) => {
    try {
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteTVChannel(selectedHotel, selectedValue.id);
        dispatch(fetchAllChannels(selectedHotel));
        dispatch(fetchAllBouquets(selectedHotel));
        dispatch(fetchAllCategorys(selectedHotel));
        dispatch(fetchChannelNumberList(selectedHotel));

        notificationManager('success', 'Channel deleted successfully');
      }
      handleClose(e);
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Channel');
      }
      handleClose(e);
    }
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
    });
  };
  const dragDisabled = !dragEnabled || channel?.length <= 1;
  const handleCellMenuClick = (event, channel) => {
    event.stopPropagation();
    setSelectedValue({
      id: channel.id,
      name: channel.name,
      title: '',
      description: '',
      status: false,
      anchorEl: event.currentTarget,
      channel: channel,
    });
  };

  const onClickView = (e) => {
    e.stopPropagation();
    onViewToggle(TVCHANNEL_CHANNELS_VIEW, true, selectedValue.channel);
  };

  const onOpenDrawer = (event, type) => {
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.channel);
    handleClose(event);
  };

  const onViewDetails = (channelClicked, event) => {
    event.stopPropagation();
    if (event?.target?.tagName === 'TD') {
      onViewToggle(TVCHANNEL_CHANNELS_VIEW, true, channelClicked);
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      channel: null,
    });
  };

  const resetFilterDataList = () => {
    if (categoryList && categoryList.length > 0) {
      var categoryListData = categoryList.map((value) => {
        return {
          id: value.name,
          name: value.name,
          selected: false,
        };
      });
      categoryListData = categoryListData.filter(
        (v, i, a) => a.findIndex((v2) => v2.name === v.name) === i,
      );
      CHANNEL_FILTER_DATA[1].subMenu = categoryListData;
      CHANNEL_FILTER_DATA[2].subMenu = LANGUAGES;
      CHANNEL_FILTER_DATA[3].subMenu = CHANNEL_DRM;
      setChannelFilter(CHANNEL_FILTER_DATA);
    }
  };
  const onChangeStatus = async (event, payload) => {
    event.stopPropagation();
    resetFilterDataList();
    try {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const item = { ...payload };
      item.status = !payload.status;

      await changeTVChannelStatus(selectedHotel, item.id, item.status, language);
      notificationManager(
        'success',
        item.status ? 'Channel activated successfully' : 'Channel deactivated successfully',
      );
      dispatch(fetchAllChannels(selectedHotel));
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed');
      }
    }
    handleClose(event);
  };

  const filteredRecoard = (filters, field) => {
    if (field === 'all') {
      setFilteredBaseList(channelList);
      setChannel(channelList);
      resetFilterDataList();
    } else {
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      const filteredRecords = channelList?.filter((data) => {
        const doesFilterSatisfy = filterIdWithFields?.map((filter) => {
          return filter.id.includes(data[filter.field]);
        });
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(filteredRecords);
      setChannel(filteredRecords);
    }
  };

  useEffect(() => {
    resetFilterDataList();
  }, [categoryList[0]]);

  useEffect(() => {
    if (loading || channel?.length === 0) return;
    const totalItems = channel?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [channel?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const onClickUpload = (e) => {
    setUploadState(true);
  };

  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllChannels(selectedHotel));
    setCsvUploadStatus(null);
    setUploadState(false);
  };

  const handleCsvFileData = (itemsList) => {
    const isTemplateInstructionRow = (row) => {
      const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
      const joined = values.join(' ');
      const instructionPatterns = [
        'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
        'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
        'max char', 'required field', 'this field', 'drop down', 'dropdown',
        'select from', 'free text', 'auto populate', 'auto-populate',
      ];
      if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
      if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
      return false;
    };
    const filteredItemList = itemsList.filter((row) => !isTemplateInstructionRow(row));
    if (filteredItemList.length === 0) {
      setValidationErrors(['No data rows found in the uploaded file.']);
      setCsvValidateError(true);
      return;
    }

    const databaseNames = new Set((channelList || []).map(ch => ch?.name?.trim()?.toLowerCase()).filter(Boolean));
    const databaseCodes = new Set((channelList || []).map(ch => ch?.code?.trim()?.toLowerCase()).filter(Boolean));
    const databaseNums = new Set((channelList || []).map(ch => ch?.number?.trim()).filter(Boolean));

    const nameFreq = Object.create(null);
    const codeFreq = Object.create(null);
    const numFreq = Object.create(null);

    const getVal = (obj, keys) => {
      const foundKey = Object.keys(obj).find((k) => keys.includes(k.toLowerCase().replace(/[-_ ]/g, '')));
      return foundKey ? obj[foundKey] : undefined;
    };

    filteredItemList.forEach(item => {
      const nK = (getVal(item, ['channelname']) || '').toString().trim().toLowerCase();
      const cK = (getVal(item, ['channelcode']) || '').toString().trim().toLowerCase();
      const numK = (getVal(item, ['channelno', 'channelnumber']) || '').toString().trim();
      if (nK) nameFreq[nK] = (nameFreq[nK] || 0) + 1;
      if (cK) codeFreq[cK] = (codeFreq[cK] || 0) + 1;
      if (numK) numFreq[numK] = (numFreq[numK] || 0) + 1;
    });

    const fileDupNames = new Set(Object.keys(nameFreq).filter(k => nameFreq[k] > 1));
    const fileDupCodes = new Set(Object.keys(codeFreq).filter(k => codeFreq[k] > 1));
    const fileDupNums = new Set(Object.keys(numFreq).filter(k => numFreq[k] > 1));

    const firstItem = filteredItemList[0] || {};
    const hasIptvFields = !!getVal(firstItem, ['ipaddress']);
    const hasCoaxialFields = !!getVal(firstItem, ['channeltype', 'digitaltelevisionformat']);

    let detectedTemplate = '';
    if (hasIptvFields && !hasCoaxialFields) detectedTemplate = 'IPTV';
    else if (hasCoaxialFields && !hasIptvFields) detectedTemplate = 'COAXIAL';

    const errors = [];
    const newItems = [];
    filteredItemList.forEach((item) => {
      const rowNum = item.__rowNum || '?';
      const rowErrors = [];
      try {
        const getValue = (obj, keys) => {
          const foundKey = Object.keys(obj).find((k) => keys.includes(k.toLowerCase().replace(/[-_ ]/g, '')));
          return foundKey ? obj[foundKey] : undefined;
        };

        const cName = (getValue(item, ['channelname']) || '').toString().trim();
        const cCode = (getValue(item, ['channelcode']) || '').toString().trim();
        const cNo = (getValue(item, ['channelno', 'channelnumber']) || '').toString().trim();
        const bouquetStr = (getValue(item, ['bouquetcode', 'bouquets']) || '').toString().trim();
        const categoryCode = (getValue(item, ['categorycode', 'category']) || '').toString().trim();
        const tvTypeStr = (getValue(item, ['tvtype', 'tvmode']) || '').toString().trim();
        const langStr = (getValue(item, ['channellanguage', 'language']) || '').toString().trim();
        const activeStr = (getValue(item, ['active', 'status', 'isactive']) || '').toString().trim();
        const isDrmStr = (getValue(item, ['isadrm', 'isdrm', 'drm', 'isadrm?']) || '').toString().trim();
        const epgUrl = (getValue(item, ['epgurl']) || '').toString().trim();
        const externalUrl = (getValue(item, ['externalurl']) || '').toString().trim();

        if (!cName) {
          rowErrors.push('"Channel Name" is empty');
        } else if (cName.length > 100) {
          rowErrors.push('"Channel Name" exceeds 100 characters');
        }

        if (!cCode) {
          rowErrors.push('"Channel Code" is empty');
        } else {
          if (cCode.length > 8) rowErrors.push('"Channel Code" exceeds 8 characters');
          if (!validateAlphanumeric(cCode)) rowErrors.push('"Channel Code" must be alphanumeric');
        }

        if (!cNo) {
          rowErrors.push('"Channel No" is empty');
        } else if (!/^\d+$/.test(cNo)) {
          rowErrors.push('"Channel No" must be a positive integer');
        }

        if (!bouquetStr) {
          rowErrors.push('"Bouquet Code" is empty');
        } else {
          const invalidBouquets = bouquetStr.split(',').filter((bc) => bc.trim() && bouquetList.findIndex((b) => b?.code?.trim()?.toLowerCase() === bc?.trim()?.toLowerCase()) === -1).map((bc) => bc.trim());
          if (invalidBouquets.length > 0) rowErrors.push(`"Bouquet Code" '${invalidBouquets.join(', ')}' not found`);
        }

        if (!categoryCode) {
          rowErrors.push('"Category Code" is empty');
        } else if (categoryList.findIndex((c) => c?.code?.trim()?.toLowerCase() === categoryCode.toLowerCase()) === -1) {
          rowErrors.push(`"Category Code" '${categoryCode}' not found`);
        }

        if (!tvTypeStr) {
          rowErrors.push('"TV Type" is empty');
        } else if (detectedTemplate && tvTypeStr.toUpperCase() !== detectedTemplate) {
          rowErrors.push(`"TV Type" should be ${detectedTemplate}`);
        } else if (!detectedTemplate && !['iptv', 'coaxial'].includes(tvTypeStr.toLowerCase())) {
          rowErrors.push('"TV Type" must be IPTV or Coaxial');
        } else if (detectedTemplate && tvTypeStr.toUpperCase() !== detectedTemplate) {
          rowErrors.push(`"TV Type" should be ${detectedTemplate}`);
        }

        if (!langStr) {
          rowErrors.push('"Channel Language" is empty');
        } else if (!LANGUAGES.some((lang) => lang.name.toLowerCase() === langStr.toLowerCase() || lang.id.toLowerCase() === langStr.toLowerCase())) {
          rowErrors.push(`"Channel Language" '${langStr}' is not valid`);
        }

        const isValidStatus = (status) => {
          const temp = (status || '').toString().toLowerCase().trim();
          return temp === 'yes' || temp === 'no';
        };

        if (activeStr && !isValidStatus(activeStr)) {
          rowErrors.push('"Active" must be Yes or No');
        }

        if (isDrmStr && !isValidStatus(isDrmStr)) {
          rowErrors.push('"Is a DRM" must be Yes or No');
        }

        if (epgUrl && !validateUrl(epgUrl)) {
          rowErrors.push('Invalid "EPG URL" format');
        }
        if (externalUrl && !validateUrl(externalUrl)) {
          rowErrors.push('Invalid "External URL" format');
        }

        const tvTypeForValidation = (detectedTemplate || tvTypeStr || '').toUpperCase();
        if (tvTypeForValidation === 'IPTV') {
          const ip = (getValue(item, ['ipaddress', 'url', 'iptvurl']) || '').toString().trim();
          const port = (getValue(item, ['port']) || '').toString().trim();
          if (!ip) rowErrors.push('"IP Address" is required for IPTV');
          if (!port) rowErrors.push('"Port" is required for IPTV');
        }

        if (tvTypeForValidation === 'COAXIAL') {
          const channelType = (getValue(item, ['channeltype', 'digitaltelevisionformat']) || '').toString().trim().toLowerCase();
          if (!channelType) {
            rowErrors.push('"Channel Type" is required for Coaxial');
          } else if (!['dtv', 'sdtv', 'cdtv'].includes(channelType)) {
            rowErrors.push('"Channel Type" must be DTV, SDTV, or CDTV');
          }
        }

        const nK = cName.toLowerCase();
        const cK = cCode.toLowerCase();
        const nameExists = nK && (databaseNames.has(nK) || fileDupNames.has(nK));
        const codeExists = cK && (databaseCodes.has(cK) || fileDupCodes.has(cK));
        const numExists = cNo && (databaseNums.has(cNo) || fileDupNums.has(cNo));

        if (codeExists || nameExists || numExists) {
          const reasons = [];
          if (nameExists) reasons.push(`name '${cName}'`);
          if (codeExists) reasons.push(`code '${cCode}'`);
          if (numExists) reasons.push(`number '${cNo}'`);
          rowErrors.push(`Already exists or duplicated in file (${reasons.join(' and ')})`);
        }
      } catch (e) {
        rowErrors.push('Unexpected error reading row data');
      }

      if (rowErrors.length > 0) {
        errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
      } else {
        newItems.push(item);
      }
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(false);
      return;
    }

    if (newItems.length > 0) {
      const listToUpload = newItems.map((item) => {
        const getValue = (obj, keys) => {
          const foundKey = Object.keys(obj).find((k) => keys.includes(k.toLowerCase().replace(/[-_ ]/g, '')));
          return foundKey ? obj[foundKey] : undefined;
        };

        const cName = (getValue(item, ['channelname']) || '').toString().trim();
        const cCode = (getValue(item, ['channelcode']) || '').toString().trim();
        const cNo = (getValue(item, ['channelno', 'channelnumber']) || '').toString().trim();
        const bouquetStr = (getValue(item, ['bouquetcode', 'bouquets']) || '').toString().trim();
        const categoryCodeStr = (getValue(item, ['categorycode', 'category']) || '').toString().trim();
        const tvTypeStr = (getValue(item, ['tvtype', 'tvmode']) || '').toString().trim().toUpperCase();
        const langStr = (getValue(item, ['channellanguage', 'language']) || '').toString().trim().toLowerCase();
        const activeStr = (getValue(item, ['active', 'status', 'isactive']) || '').toString().trim().toUpperCase();
        const isDrmStr = (getValue(item, ['isadrm', 'isdrm', 'drm', 'isadrm?']) || '').toString().trim().toUpperCase();
        const epgUrl = (getValue(item, ['epgurl']) || '').toString().trim();
        const externalUrl = (getValue(item, ['externalurl']) || '').toString().trim();

        const channelCat = categoryList.find((c) => c?.code?.trim()?.toLowerCase() === categoryCodeStr.toLowerCase());
        
        const iptv = { 
          url: (getValue(item, ['ipaddress', 'url']) || '').toString().trim(), 
          port: (getValue(item, ['port']) || '').toString().trim() 
        };
        
        const coaxial = {
          digitalTelevisionFormat: (getValue(item, ['channeltype', 'digitaltelevisionformat']) || '').toString().trim().toLowerCase(),
          frequency: (getValue(item, ['frequency']) || '').toString().trim(),
          broadCastStandard: (getValue(item, ['broadcaststandard']) || '').toString().trim(),
          modulationType: (getValue(item, ['modulationtype']) || '').toString().trim(),
          bandwidth: (getValue(item, ['bandwidth']) || '').toString().trim(),
          satelliteId: (getValue(item, ['satelliteid']) || '').toString().trim(),
          programNumber: (getValue(item, ['programnumber']) || '').toString().trim(),
          majorNumber: (getValue(item, ['majornumber']) || '').toString().trim(),
          polarization: (getValue(item, ['polarization']) || '').toString().trim(),
          symbolRate: (getValue(item, ['symbolrate']) || '').toString().trim(),
        };

        const bouquetInput = bouquetStr.split(',').map((bc) => {
          const bouquet = bouquetList.find((b) => b?.code?.trim()?.toLowerCase() === bc?.trim()?.toLowerCase());
          return bouquet ? { id: bouquet.id, name: bouquet.name } : null;
        }).filter(Boolean);

        return {
          name: cName,
          code: cCode,
          number: cNo,
          categoryId: channelCat?.id,
          categoryName: channelCat?.name,
          language: langStr,
          description: (item.description || '').toString().trim(),
          externalURL: externalUrl,
          isDRM: isDrmStr === 'YES',
          tvType: tvTypeStr,
          status: activeStr === 'YES',
          isEpgURL: !!epgUrl,
          epgURL: epgUrl,
          iptv,
          coaxial,
          bouquet: bouquetInput,
        };
      });
      setValidationErrors([]);
      setCsvValidateError(false);
      handleCsvDataSubmit(false, listToUpload);
    } else {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(false);
    }
  };

  const handleCsvDataSubmit = async (isReplacing, payloadLists) => {
    setCsvUploadStatus('uploading');
    try {
      const payload = {
        isReplace: isReplacing,
        hotelId: selectedHotel,
        tvChannels: payloadLists,
      };
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const res = await uploadBulkTvChannelsByCSV(payload, language);
      if (res?.data?.uploadTvChannelsByCSV?.status === 'Success') {
        setCsvUploadStatus('success');
      } else {
        setCsvUploadStatus('error');
      }
    } catch (e) {
      setCsvUploadErrorMsg(null);
      setCsvUploadStatus('server-error');
    }
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const generateExportData = (channelsList) => {
    let tempList = channelsList?.map((e) => {
      const baseData = {
        name: e?.name,
        code: e?.code,
        number: e?.number,
        categoryCode: categoryList?.find((c) => c.id === e.categoryId)?.code,
        bouquetCode: bouquetList
          ?.filter((element) => e?.bouquet?.map((e) => e.id).includes(element?.id))
          ?.map((b) => b.code),
        language: e?.language,
        description: e?.description,
        tvType: e?.tvType,
        externalURL: e?.externalURL,
        epgURL: e?.epgURL,
        isDrm: e?.isDRM ? 'YES' : 'NO',
        active: e?.status ? 'YES' : 'NO',
      };

      if (e?.tvType === 'IPTV') {
        return {
          ...baseData,
          ip_address: e?.iptv?.url || '',
          port: e?.iptv?.port || '',
          frequency: '',
          broadCastStandard: '',
          modulationType: '',
          bandwidth: '',
          programNumber: '',
          majorNumber: '',
          satelliteId: '',
          polarization: '',
          symbolRate: '',
          channelType: '',
        };
      }
      if (e.tvType === 'COAXIAL') {
        return {
          ...baseData,
          ip_address: '',
          port: '',
          frequency: e?.coaxial?.frequency || '',
          broadCastStandard: e?.coaxial?.broadCastStandard || '',
          modulationType: e?.coaxial?.modulationType || '',
          bandwidth: e?.coaxial?.bandwidth || '',
          programNumber: e?.coaxial?.programNumber || '',
          majorNumber: e?.coaxial?.majorNumber || '',
          satelliteId: e?.coaxial?.satelliteId || '',
          polarization: e?.coaxial?.polarization || '',
          symbolRate: e?.coaxial?.symbolRate || '',
          channelType: e?.coaxial?.digitalTelevisionFormat || '',
        };
      }
      return baseData;
    });
    const fields = [
      'name',
      'code',
      'number',
      'categoryCode',
      'bouquetCode',
      'language',
      'description',
      'tvType',
      'externalURL',
      'epgURL',
      'isDrm',
      'active',
      'ip_address',
      'port',
      'channelType',
      'frequency',
      'broadCastStandard',
      'modulationType',
      'bandwidth',
      'programNumber',
      'majorNumber',
      'satelliteId',
      'polarization',
      'symbolRate',
    ];

    return tempList?.map((record) =>
      Object.fromEntries(
        Object.entries(record)
          .filter(([key]) => fields.includes(key))
          .map(([key, value]) => [key, value !== undefined && value !== null ? String(value) : '']),
      ),
    );
  };
  const generateHeaders = [
    { label: 'Channel Name', key: 'name' },
    { label: 'Channel Code', key: 'code' },
    { label: 'Category Code', key: 'categoryCode' },
    { label: 'Bouquet Code', key: 'bouquetCode' },
    { label: 'Channel No', key: 'number' },
    { label: 'Channel Language', key: 'language' },
    { label: 'Description', key: 'description' },
    { label: 'TV Type', key: 'tvType' },
    { label: 'External URL', key: 'externalURL' },
    { label: 'Channel Type', key: 'channelType' },
    { label: 'Frequency', key: 'frequency' },
    { label: 'Broadcast Standard ', key: 'broadCastStandard' },
    { label: 'Modulation Type ', key: 'modulationType' },
    { label: 'Bandwidth ', key: 'bandwidth' },
    { label: 'Program Number ', key: 'programNumber' },
    { label: 'Major Number ', key: 'majorNumber' },
    { label: 'Satellite ID', key: 'satelliteId' },
    { label: 'Polarization', key: 'polarization' },
    { label: 'Symbol Rate', key: 'symbolRate' },
    { label: 'EPG URL', key: 'epgURL' },
    { label: 'Is a DRM', key: 'isDrm' },
    { label: 'Active', key: 'active' },
  ];

  const onSortChannelNumber = async () => {
    try {
      let payload = {
        hotelId: selectedHotel,
        isSort: true,
      };
      const res = await sortChannels(payload);
      const item = res?.data?.sortChannel;
      notificationManager(item.status ? 'success' : 'error', item.message);
      dispatch(fetchAllChannels(selectedHotel));
      if (res?.data?.sortChannel?.status === 'Success') {
        setCsvUploadStatus('success');
      } else {
        setCsvUploadStatus('error');
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Channel Info'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Channels'
          sectionTItle='TV Channels'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/TV_Channel_CSV_Templates.zip'}
        />
      </Dialog>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteChannelAPICall}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      <div className='row mx-2 d-flex'>
        <SearchBar
          type={TVCHANNEL_CHANNELS_CREATE}
          buttonName='Add Channel'
          setSearchText={handleSearchText}
          onOpenDrawer={onOpenDrawer}
          displayAddOrEdit={
            permissions[RBAC_TYPE_CMS_TVCHANNELS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
              ? 'show'
              : 'hide'
          }
          filterList={channelFilter}
          setFilterDataList={setChannelFilter}
          filteredRecoard={filteredRecoard}
          visible={visible}
          setVisible={setVisible}
          actionMenuItems={[]}
          popUp={popUp}
          setPopUp={setPopUp}
          placeHolder={channel}
          setPlaceHolder={setChannel}
          globalPlaceHolder={channelList}
          setGlobalPlaceHolder={setChannelsSuccess}
          dispatch={dispatch}
          mappingApi={updateLiveTvOrders}
          displayText='TV channels'
          module='TV_CHANNEL'
          searchText={searchText}
          setSearch={setSearchText}
          extraSecondaryBtnDisplay={true}
          extraSecondaryBtnText='Upload'
          onClickSecondaryBtn={onClickUpload}
          exportBtn
          exportBtnTitle='Export'
          exportData={generateExportData(channel)}
          headers={generateHeaders}
          isSortAvailable={showSort}
          onSortChannelNumber={onSortChannelNumber}
          setDrag={setDragEnabled}
        />
      </div>
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          channel && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell className='w-40'>Name</TableCell>
                    <TableCell className='w-40'>Category</TableCell>
                    <TableCell className='w-30'>Code</TableCell>
                    <TableCell className='w-40' align='right'>
                      Channel Number
                    </TableCell>
                    <TableCell className='w-50' align='center'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>
                <DragDropContext onDragEnd={handleDragEnd} isDropDisabled={dragDisabled}>
                  <Droppable droppableId='cms' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? channel.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : channel
                        ).map((channelItem, i) => (
                          <Draggable
                            key={channelItem.id}
                            draggableId={channelItem.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={channelItem.id}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(channelItem, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell>
                                  {!dragDisabled && (
                                    <DragIndicator className='res-menu-accordion-drag' />
                                  )}
                                </TableCell>
                                <TableCell className='w-35'>{channelItem?.name}</TableCell>
                                <TableCell className='w-35'>{channelItem?.categoryName}</TableCell>
                                <TableCell className='w-30'>{channelItem?.code}</TableCell>
                                <TableCell className='w-40' align='right'>
                                  {channelItem?.number}
                                </TableCell>
                                <TableCell className='w-50'>
                                  <div className='d-flex justify-content-center'>
                                    <div
                                      className={`${channelItem?.statusClass} pill d-flex justify-content-center align-items-center`}
                                    >
                                      <span className='ms-1'>{channelItem?.statusText}</span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_CMS_TVCHANNELS] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, channelItem);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === channelItem.id
                                    }
                                    onClose={(e) => {
                                      handleClose(e);
                                    }}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onChangeStatus(e, selectedValue.channel);
                                      }}
                                    >
                                      {selectedValue.channel?.status === true ? (
                                        <>
                                          <RemoveCircle className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, TVCHANNEL_CHANNELS_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteChannel(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={channel.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
      </div>
    </div>
  );
};

export default ChannelList;
